// Legacy page-level top badge. The SAP_ID badge now lives in the global header
// (app bar) via _shared/Top/Topbar, so this page-level duplicate renders
// nothing. Kept as a no-op export because ~37 pages still import and pass it as
// the DashGrid `Top` slot.
const TopBar = () => null;

export default TopBar;
